module.exports = __webpack_public_path__ + "static/media/dark_blue-l.bffb4870.svg";